import { useMediaQuery } from '@mui/material';

function useMobile() {
  const isMobile = useMediaQuery('(max-width:720px)');

  return { isMobile };
}

export default useMobile;
